import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const WhyBookStyle = styled('div')`
    .box-why {
        ${typography.bodyXs}
        color: var(--sand-700);
        .why-title {
            ${typography.bodyL}
            margin-bottom: 12px;
        }
        .link {
            color: var(--blue-400);
            cursor: pointer;
            text-decoration-line: underline;
        }
    }

    @media screen and (min-width: 1200px) {
        .box-why {
            max-width: 203px;
        }
        .ant-row {
            .ant-col:first-child .why-detail {
            max-width: 183px;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .box-why {
            margin-bottom: 24px;
        }
    }
`;
export default WhyBookStyle;
